import swal from 'sweetalert2';
import Select from 'react-select';
import { useEffect, useState } from "react";
import * as helper from '../global/helper';
import { postGuest } from '../api/usersAPI';

const AddGuest = (props) => {
    const [guest,                   setGuest]                     = useState({});
    const [genderOption,            setGenderOption]              = useState([{ value:  'Male', label: 'Male'}, { value:  'Female', label: 'Female'},]);

    useEffect(() => {
        $('#modalGuest').modal({ backdrop: 'static' });
        $('#modalGuest').on('hidden.bs.modal', function () {
            $('.modal').hasClass('show') && $('body').addClass('modal-open');
            props.onDismissModal(false);
        });
        $('#txtDOB').datepicker({
            format: 'dd-mm-yyyy',
            minDate: new Date(),
        });
        $('#txtDOB').on('change', function (event) {
            updateGuestDetails('DOB',  moment(event.target.value, 'DD-MM-YYYY').format('YYYY-MM-DD'))
        }); 
    }, [])

    const updateGuestDetails = (field, value) => { 
        setGuest((d) => {
            return { ...d, [field]: value };
        });
    };

    const addGuestHandler = async(e) => {
        e.preventDefault()
        const form = $('#add-guest-form');
        
        form.validate({
            rules: {
                txtGuestName: { required: true },
                txtGuestMobile: {
                    required: true,
                    number: true,
                },          
                ddlGender: { required: true },
                txtHandicap: { required: true },                                                   
            },
            messages: {
                txtGuestName: { required: "Please enter name"},
                txtGuestMobile: { required: "Please enter mobile"},
                ddlGender: { required: "Please select gender"},
                txtHandicap: { required: "Please enter handicap"},
            }
        });

        if (!form.valid()) return;
        const btn = $('#btnSaveGuest');

        try {
            helper.StartProcessing(btn);

            let gType = ( props.UserReferenceID != null)? 'user' : 'guest';

            const guestDetails = {
                ID:            guest.ID || 0,
                RefID:         props.UserReferenceID != null ? props.UserReferenceID : 0,
                SubCategoryID: props.SubCategoryID,
                Name:          guest.Name,
                Email:         guest.Email || '',
                Gender:        guest.Gender || '',
                Handicap:      guest.Handicap || '',
                IGUNumber:     guest.IGUNumber || '',
                Photo:         '',
                Mobile:        guest.Mobile,
                Active:        "Y"
            }
            const newG = await postGuest(guestDetails);
        
            if(props.from == 'mat'){
                // props.setGuestList((m) => [newG, ...m]);
                props.guestList.current = [newG, ...props.guestList.current];
                props.setBookSheet((d) => {
                    return { ...d,  OwnerID: (props.guestUserID || 0), UserType: "Guest" ,UserID: newG.ID};
                });
                // props.setBookingSheet('UserID', newG.ID);
                // props.guestUserID ? props.setBookingSheet('OwnerID', props.guestUserID) : 0;
                props.setSubCatID(newG.SubCategoryID);
                props.bookingUserList({ ...newG, UserID: newG.ID });
            }else{
                // Directly Add New Guest to Book User List
                props.addGuestToBooking(gType, {...newG, TeeTimeBookID: 0});
                // props.bookingUserList.push({...newG,  UserID: newG.ID})
            }
            $('#modalGuest').modal('hide');
            // props.fetchBookingDetails()
            swal.fire({
                icon: 'success',
                titleText: 'Guest added successfully!',
                showConfirmButton: false,
                timer: 1500,
            });
        
       } catch (err) {
            swal.fire({
                icon                  : 'error',
                titleText             : 'Error!',
                text                  : err.message,
                buttonsStyling        : false,
                confirmButtonClass    : 'btn btn-brand',
            });
       }finally{
            helper.StopProcessing(btn);
       }
    }   

    return(
        <>
            <div id="modalGuest" className="modal fade modal-responsive" tabIndex="-1" role="dialog" >
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Add Guest</h5>
                            <button 
                                type="button" 
                                className="close" 
                                data-dismiss="modal" 
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <form className="kt-form" id="add-guest-form">
                                <div id="ModalGuestHolder" className="kt-form kt-form--label-right" role="form">
                                    <div className="form-group row">
                                        <label className="col-form-label col-lg-3">Name <span className="red">*</span></label>
                                        <div className="col-xl-6 col-lg-8">
                                            <input 
                                                id="txtGuestName" 
                                                name="txtGuestName" 
                                                type="text" 
                                                className="form-control" 
                                                value={guest.Name || ''}
                                                onChange={(event) => updateGuestDetails('Name', helper.camelCase(event.target.value))} 
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label className="col-form-label col-lg-3"> Mobile <span className="red">*</span></label>
                                        <div className="col-xl-6 col-lg-8">
                                            <input 
                                                id="txtGuestMobile" 
                                                name="txtGuestMobile" 
                                                type="text" 
                                                className="form-control"
                                                minLength='10'
                                                maxLength='10'
                                                value={guest.Mobile || ''}
                                                onChange={(event) => updateGuestDetails('Mobile', event.target.value)} 
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-form-label col-lg-3">Gender <span className="red">*</span></label>
                                        <div className="col-xl-6 col-lg-8">
                                            <Select 
                                                id="ddlGender" 
                                                name="ddlGender"
                                                className="multi-custom"
                                                placeholder="Select Gender"
                                                value={guest && genderOption.find((m) => m.value == guest.Gender) || ''}
                                                onChange={(event) => updateGuestDetails('Gender', event.value)}
                                                options={genderOption}
                                            />
                                        </div>
                                    </div> 
                                    <div className="form-group row">
                                        <label className="col-form-label col-lg-3">Handicap<span className="red">*</span></label>
                                        <div className="col-xl-6 col-lg-8">
                                            <input 
                                                id="txtHandicap" 
                                                name="txtHandicap" 
                                                type="number" 
                                                className="form-control"
                                                value={guest.Handicap || ""}
                                                onChange={(event) => updateGuestDetails('Handicap', event.target.value)} 
                                            />
                                        </div>
                                    </div>  
                                    <div className="form-group row">
                                        <label className="col-form-label col-lg-3">Email </label>
                                        <div className="col-xl-6 col-lg-8">
                                            <input 
                                                id="txtGuestEmail" 
                                                name="txtGuestEmail" 
                                                type="text" 
                                                className="form-control" 
                                                value={guest.Email || ''}
                                                onChange={(event) => updateGuestDetails('Email', event.target.value)} 
                                            />
                                        </div>
                                    </div>
                                   
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="button" id="btnSaveGuest" name="btnSaveGuest" className="btn btn-brand margin-0 " onClick={addGuestHandler}>Add</button>
                            <button type="button" className="btn btn-secondary margin-0 margin-r5" data-dismiss="modal">Close</button>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddGuest;